/* src/app/components/companies-components/companies-company-dashboard/companies-company-dashboard.component.scss */
:host > div {
  display: flex;
  flex-direction: row;
}
:host > div > app-companies-company-image-card {
  flex-basis: 50%;
}
/*# sourceMappingURL=companies-company-dashboard.component.css.map */
